import NetworkService from './network.service'
import { Role, User } from '../modules/user/interfaces/user.interface';

class UserApi {

  static createUser = async (userData: User) => {
    let url = `api/common-service/users`;
    let data = await NetworkService.post(url, userData)
    return data && data.data
      ? data.data : data
  }

  static createRole = async (roleData: Role) => {
    let url = `api/common-service/users/roles`;
    let data = await NetworkService.post(url, roleData)
    return data && data.data
      ? data.data : data
  }

  static updateRole = async (roleId: string, roleData: Role) => {
    let url = `api/common-service/users/roles/${roleId}`;
    let data = await NetworkService.put(url, roleData)
    return data && data.data
      ? data.data : data
  }

  static updateUser = async (userId: string, userData: User) => {
    let url = `api/common-service/users/${userId}`;
    let data = await NetworkService.put(url, userData)
    return data && data.data
      ? data.data : data
  }
  
  static getUsers = async (query: string = '', limit: number = 10, page: number = 1) => {
    let url = `api/common-service/users`;
    let config = {
      params: {
        searchQuery: query,
        page,
        limit
      }
    }
    let data = await NetworkService.get(url, config)
    return data && data.data
      ? data.data : data
  }

  static getRoles = async (query: string = '', limit: number = 10, page: number = 1) => {
    let url = `api/common-service/users/roles`;
    let config = {
      params: {
        searchQuery: query,
        page,
        limit
      }
    }
    let data = await NetworkService.get(url, config)
    return data && data.data
      ? data.data : data
  }

  static getPermissions = async (query: string = '', limit: number = 10, page: number = 1) => {
    let url = `api/common-service/users/permissions`;
    let config = {
      params: {
        searchQuery: query,
        page,
        limit
      }
    }
    let data = await NetworkService.get(url, config)
    return data && data.data
      ? data.data : data
  }

  static getFeatures = async (query: string = '', limit: number = 10, page: number = 1) => {
    let url = `api/common-service/users/features`;
    let config = {
      params: {
        searchQuery: query,
        page,
        limit
      }
    }
    let data = await NetworkService.get(url, config)
    return data && data.data
      ? data.data : data
  }

  static forceLogoutUsers = async (userIds: number[]) => {
    let url = `api/common-service/users/force-logout`;
    let data = await NetworkService.post(url, { userIds })
    return data && data.data ? data.data : data
  }

}
export default UserApi;